import styled, { css, ThemeProps } from 'styled-components';
import { Theme } from '../theme';
import { StyledDivComponent, StyledSpanComponent } from '../types';
import { FontIconProps, FontIconSpan } from './FontIcon';
import { SocialLinks, SocialIcon, SocialIconSvg } from './SocialMedia';

type ShareLayerLinkProps = FontIconProps & {
  active?: boolean;
};

type ShareLayerLinkPropsThemed = ThemeProps<Theme> & ShareLayerLinkProps;

export const ShareLayerLink: StyledSpanComponent<
  ShareLayerLinkProps
> = FontIconSpan.extend`
  display: block;
  right: 125px;
  position: absolute;
  height: 100%;
  padding: 0 15px;
  color: ${(props: ShareLayerLinkPropsThemed) => props.theme.colors.grayMedium};
  cursor: pointer;

  &:before {
    margin: 0;
    font-size: 3rem;
    line-height: 6rem;
  }

  ${(props: ShareLayerLinkPropsThemed) =>
    !props.active &&
    css`
      &:after {
        content: '';
        position: absolute;
        top: 50%;
        width: 1px;
        height: 36px;
        background: ${props.theme.colors.grayLight};
        transform: translateY(-50%);
        right: 0;
      }
    `}

  ${(props: ShareLayerLinkPropsThemed) =>
    props.active &&
    css`
      background: ${props.theme.colors.dataLayer};
      color: ${props.theme.colors.white};
    `}
`;

type ShareLayerProps = {
  show?: boolean;
};

type ShareLayerPropsThemed = ThemeProps<Theme> & ShareLayerProps;

export const ShareLayer: StyledDivComponent<ShareLayerProps> = styled.div`
  display: none;
  right: 125px;
  width: 60px;
  position: fixed;
  z-index: 200;

  ${(props: ShareLayerPropsThemed) =>
    props.show &&
    css`
      display: block;
      background: ${props.theme.colors.dataLayer};
      color: ${props.theme.colors.white};
  `}

  ${SocialLinks} {
    text-align: center;
    width: 100%;

    ${SocialIcon} {
      color: ${(props) => props.theme.colors.white};
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: center;

      &:before {
        margin-right: 0px;
      }
    }

    ${SocialIconSvg} {
      fill: ${(props) => props.theme.colors.white};
      height: 30px;
      margin: 15px 20px;
    }
  }
`;
